function verifyCallback(response) {
  $.ajax({
    type: 'POST',
    url: '/ajax/login/captcha',
    data: { 'token': response },
    success: function (data) { },
    dataType: 'json'
  });
}

function formatToE164(phoneNumber, countryCode) {
  // Remove all non-numeric characters
  let cleaned = phoneNumber.replace(/\D/g, '');

  // Add the country code if it doesn't already have one
  if (cleaned.length === 10 && countryCode) {
    cleaned = countryCode + cleaned;
  } else if (cleaned.length < 10) {
    throw new Error('Invalid phone number');
  }

  // Prefix with '+' for E.164 format
  return '+' + cleaned;
}


const successCallbacks = {
  'rfiSuccess': function ($form) {
    window.dataLayer = window.dataLayer || [];
    const formData = $form.serializeArray();
    const user = {};

    formData.forEach(function (field) {
      user[field.name] = field.value;
    });

    if (window.analytics) {
      window.analytics.identify({
        email: user.email,
        firstName: user.firstname,
        lastName: user.lastname,
        phone: formatToE164(user.phonenumber, '+1'),
        company: {
          name: user['organization-name'],
        },
        organizationType: user['organization-type'],
        organizationSize: user['organization-size'],
      });


    window.analytics.track('Request Information Form Submitted');
  }
    dataLayer.push({
    'event': 'onboarding',
    'onboarding_step': 'rfi',
  });

  $('#rfi-form').modal('hide');
  $('#rfi-form-2').modal('show');
}
}

export function ajaxForms() {
  let recaptcha_loaded = false;
  widgetId1 = null;

  $('form.dmcCatchForm[data-url]').on('submit', async function (e) {
    if (recaptcha_loaded === false) {
      $.getScript("https://www.google.com/recaptcha/enterprise.js?render=explicit", function (data, textStatus, jqxhr) { });
      recaptcha_loaded = true;
      const sibu = $('form.dmcCatchForm').find('button:contains("Sign In")');
      $('<div id="recaptcha_new" style="margin-bottom: 10px;"></div>').insertBefore(sibu);
    }
    e.preventDefault();
    const $form = $(this);
    const from_redirect_page = $form.data('redirect-url');
    $form.find('.dmcform').hide();

    const $submitButton = $form.find('button[type="submit"]');
    const $submitButtonText = $submitButton.text();

    // Disable the submit button to prevent multiple submissions
    $submitButton.prop('disabled', true).text('Processing...');

    if (window.grecaptcha) {
      const captchaToken = await window.grecaptcha.execute(
        '6Lcq0bYgAAAAAKFf_SQeob_0miAAww_viAaFIoZg',
        { action: "submit" },
      );

      $form.append(`<input type="hidden" name="captchaToken" value="${window.e2eCaptchaToken || captchaToken}" />`);
    }


    $.ajax({
      type: $form.data('method'),
      url: $form.data('url'),
      data: $form.serialize(),
      crossDomain: true,
      error: function () {
        $submitButton.prop('disabled', false).text($submitButtonText);
        alert('There was an error processing your request. Please try again.')
      },
      success: function (data) {
        $submitButton.prop('disabled', false).text($submitButtonText);
        const successcallbacks = $form.data('success-callbacks') || false;
        const errorcallbacks = $form.data('error-callbacks') || false;
        if (typeof data.classes !== "undefined") {
          $.each(data.classes, function (k, v) {
            if (v == '2fa') {
              $('.nontwofa').hide();
              $('.twofa').show();
              $('#loginButton').html('Verify')
              $('.authentication-caption h1').html('Verify Your Account')
              $('#2factorCode').val('');
              $('#2factorCode').focus();
            } else if (v == 'captcha') {
              if ($('#recaptcha_new').length == 0) {
                const sibu = $('form.dmcCatchForm').find('button:contains("Sign In")');
                $('<div id="recaptcha_new" style="margin-bottom: 10px;"></div>').insertBefore(sibu);
              }

              if (widgetId1 !== null) {
                grecaptcha.enterprise.reset(widgetId1);
              }

              widgetId1 = grecaptcha.enterprise.render('recaptcha_new', {
                'sitekey': '6LePPcwgAAAAALdz50esfwhIq4B4F6H7aZZ-yTLB',
                'theme': 'light',
                'callback': verifyCallback
              });
            }

            $form.find('.dmcform.' + v).show()
          })
        }

        if (data.status == 'error') {
          if (typeof dmcFpJs !== "undefined") {
            dmcFpJs()
          }

          if (data.reason == 'proxy') {
            Intercom('trackEvent', 'proxy-disable');
          }

          if (typeof data.error_message !== "undefined") {
            if (typeof bootbox !== "undefined") {
              bootbox.alert(data.error_message)
            } else {
              alert(data.error_message)
            }
          }
          if (errorcallbacks !== false) {
            errorcallbacks.split(/\s*,\s*/).forEach(function (funk) {
              if (typeof errorCallbacks[funk] !== "undefined") {
                errorCallbacks[funk]()
              }
            })
          }
        } else if (data.status == 'ok') {
          if (from_redirect_page) {
            window.location.href = from_redirect_page
          }
          if (successcallbacks !== false) {
            successcallbacks.split(/\s*,\s*/).forEach(function (func) {
              if (typeof successCallbacks[func] !== "undefined") {
                successCallbacks[func]($form)
              }
            })
          }
          if (data.redirect_url) {
            window.location.href = data.redirect_url
          }
        }
      },
      dataType: 'json'
    });

    return false
  })

  $('[data-signup-form]').on('submit', function () {
    const $actionURL = $(this).data('action');
    const el = jQuery(this);
    const form_d = el.serialize() + '&' + window.dmc_csrf_tok_name + '=' + window.dmc_csrf_tok_val;
    const $submitButton = $('[data-signup-form]').find('button[type="submit"]');

    // Disable the submit button to prevent multiple submissions
    $submitButton.prop('disabled', true).text('Processing Sign Up...').attr('style', 'background-color: #E1E1E1 !important;');

    $.post($actionURL + '/ajax/signup.php', form_d,
      function (data) {
        if (data.result == 'ok') {
          window.dataLayer = window.dataLayer || [];

          dataLayer.push({
            'event': 'onboarding',
            'onboarding_step': 'signup',
            'user_email': $('[data-signup-form]').find('input[name=email]').val(),
          });

          window.location = data.url;
        } else {
          alert(data.error_msg);
          $submitButton.prop('disabled', false).text('Sign Up').attr('style', ''); // Re-Enable Sign Up Button
        }
      }, 'json').fail(function () {
        $submitButton.prop('disabled', false).text('Sign Up').attr('style', ''); // Re-Enable Sign Up Button
        alert('There was an error processing your request. Please try again.');
      });

    return false;
  });
}